import { render, staticRenderFns } from "./edit-club-light.vue?vue&type=template&id=ded2e20e"
import script from "./edit-club-light.vue?vue&type=script&lang=js"
export * from "./edit-club-light.vue?vue&type=script&lang=js"
import style0 from "./edit-club-light.vue?vue&type=style&index=0&id=ded2e20e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports